import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useResetPasswordMutation from './queries/useResetPasswordMutation';
import type { CompleteResetPasswordResponse } from '@/services/forgot-password.types';

interface UseResetPasswordSubmitArgs {
  ott: string;
  onCompleted: (response: CompleteResetPasswordResponse) => void;
}

interface ResetPasswordFormValues {
  password: string;
  confirmPassword: string;
}

const useResetPasswordSubmit = ({
  ott,
  onCompleted,
}: UseResetPasswordSubmitArgs) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>();
  const clearErrors = () => setErrorMessage(undefined);

  const mutation = useResetPasswordMutation({
    onSuccess: onCompleted,
    onError: () => setErrorMessage(t('pageForgotPassword.errorResetPassword')),
  });

  const handleSubmitResetPassword = ({ password }: ResetPasswordFormValues) => {
    clearErrors();
    mutation.mutate({ ott, newPassword: password });
  };

  return {
    clearErrors,
    errorMessage,
    handleSubmitResetPassword,
    isSubmitting: mutation.isPending,
  };
};

export default useResetPasswordSubmit;
